document.addEventListener('DOMContentLoaded', function () {
  enableDisclosure();

  function enableDisclosure() {

    const $disclosure = document.querySelectorAll('[data-disclosure]');
    const $toggle = document.querySelectorAll('[data-disclosure-toggle]');
    const $disclosureWrap = document.querySelectorAll('.disclosure__list-wrap');

    //Check if current opened menu is offscreen
    // function checkOffScreen($openedToggle) {
    //   if($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
    //     $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
    //   }
    //   this.classList.add('btn-anim');
    //   for (let sibling of $openedToggle.parentNode.children) {
    //       if (sibling.classList.contains('disclosure__list-wrap');
    //   }
    // }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if(ignoreTarget === true) {
        $toggle.forEach(el => {
          if (el != currentTarget) {
            el.classList.remove('is-clicked');
            el.setAttribute('aria-expanded', 'false');
          }
        });
      } else {
        $toggle.forEach(el => {
          if (el != currentTarget) {
            el.classList.remove('is-clicked');
            el.setAttribute('aria-expanded', 'false');
          }
        });
      }

      $disclosureWrap.forEach(d => {
        d.classList.remove('disclosure--left');
      });
    }

    //Close menus on ESC
    document.body.addEventListener('keyup', (event) => {
      if (event.code === 27) {
        closeDisclosures();
      }
    });

    //Close menus on hoverout
    $disclosure.forEach(d => {
      d.addEventListener('mouseleave', (event) => {
        closeDisclosures();
      }, false);
    });

    //On click/focus event for toggling options
    ['click', 'focus'].forEach( e => {
      $toggle.forEach(t => {
        t.addEventListener(e, evt => {
          //Close all other menus
        closeDisclosures(true, this);

        var $target = evt.currentTarget;
        $target.setAttribute('aria-expanded', 'true');
        $target.classList.add('is-clicked');
        // checkOffScreen($target);
        }, false);
      });
    });

    //When tabbing through, close dropdown when tabbing out of dropdown
    document.querySelectorAll('.disclosure__button').forEach( btn => {
      btn.addEventListener('focusout', function(e) {
      //Close all other menus
        if(e.relatedTarget && (!e.relatedTarget.classList.contains('disclosure__button') || e.relatedTarget.classList.contains('disclosure__toggle'))) {
          closeDisclosures();
        }
      });
    });

    //Mobile toggle logic
    $toggle.forEach (t => {
      t.addEventListener('touchstart', function(e) {
        if (Shopify.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          const $target = e.currentTarget;

          closeDisclosures(true, this);

          if(!$target.classList.contains('is-clicked')) {
            $target.setAttribute('aria-expanded', 'true');
            $target.classList.add('is-clicked');
            // checkOffScreen($target);
          } else {
            $target.setAttribute('aria-expanded', 'false');
            $target.classList.remove('is-clicked');
            $disclosureWrap.classList.remove('disclosure--left');
          }
        }
      });
    });

  }

  if (Currency.show_multiple_currencies || Currency.native_multi_currency) {
    currencyConverter.init();
  }
}, false);